import { create } from 'zustand'
import axios from 'axios'
import toast from 'react-hot-toast'

const API_URL = import.meta.env.VITE_API_URL || 'https://www.secs.gismac.co.ke/api'

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' }
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    }
    return Promise.reject(error)
  }
)

export const useAuthStore = create((set, get) => ({
  user: JSON.parse(localStorage.getItem('user') || 'null'),
  token: localStorage.getItem('token') || null,
  isAuthenticated: !!localStorage.getItem('token'),
  isLoading: false,
  error: null,

  login: async (email, password) => {
    set({ isLoading: true, error: null })
    try {
      const response = await api.post('/auth/login', { email, password })
      const { token, user } = response.data
      localStorage.setItem('token', token)
      localStorage.setItem('user', JSON.stringify(user))
      set({ user, token, isAuthenticated: true, isLoading: false })
      toast.success(`Welcome back, ${user.firstName}!`)
      return true
    } catch (error) {
      const message = error.response?.data?.message || 'Login failed'
      set({ error: message, isLoading: false })
      toast.error(message)
      return false
    }
  },

  logout: async () => {
    try { await api.post('/auth/logout') } catch (e) {}
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    set({ user: null, token: null, isAuthenticated: false })
    toast.success('Logged out successfully')
  },

  hasPermission: (permission) => {
    const { user } = get()
    if (!user) return false
    if (user.role === 'admin') return true
    return user.permissions?.includes(permission)
  },

  clearError: () => set({ error: null })
}))

export { api }
